/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_RecordsInputs */

const en_us2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records`)
};

const pt_br2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordes`)
};

const es_419_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récords`)
};

const pt_pt2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordes`)
};

const fr_fr2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records`)
};

const de_de2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekorde`)
};

const it_it2_workout_share_card_records = /** @type {(inputs: Workout_Share_Card_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record`)
};

/**
* | output |
* | --- |
* | "Records" |
*
* @param {Workout_Share_Card_RecordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_records = /** @type {((inputs?: Workout_Share_Card_RecordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_RecordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_records(inputs)
	if (locale === "es-419") return es_419_workout_share_card_records(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_records(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_records(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_records(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_records(inputs)
	return en_us2_workout_share_card_records(inputs)
});
export { workout_share_card_records as "workout-share.card_records" }